var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>3:0</li> '+
                            '<li>3:1</li> '+
                            '<li>3:2</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-tree">'+
                        '<ul>'+
                            '<li>3:3</li> '+
                            '<li>2:3</li> '+
                            '<li>1:3</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>0:3</li> '+
                            '<li>Other</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="3:0" data-betCode="630" class="bet-choose" data-odd="'+quotes.Score30+'">'+globalFunctions.checkQuotes(quotes.Score30)+'</li> '+
                                '<li data-betType="3:1" data-betCode="631" class="bet-choose" data-odd="'+quotes.Score31+'">'+globalFunctions.checkQuotes(quotes.Score31)+'</li> '+
                                '<li data-betType="3:2" data-betCode="632" class="bet-choose" data-odd="'+quotes.Score32+'">'+globalFunctions.checkQuotes(quotes.Score32)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-tree">'+
                            '<ul>'+
                                '<li data-betType="3:3" data-betCode="633" class="bet-choose" data-odd="'+quotes.Score33+'">'+globalFunctions.checkQuotes(quotes.Score33)+'</li> '+
                                '<li data-betType="2:3" data-betCode="623" class="bet-choose" data-odd="'+quotes.Score23+'">'+globalFunctions.checkQuotes(quotes.Score23)+'</li> '+
                                '<li data-betType="1:3" data-betCode="613" class="bet-choose" data-odd="'+quotes.Score13+'">'+globalFunctions.checkQuotes(quotes.Score13)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="0:3" data-betCode="603" class="bet-choose" data-odd="'+quotes.Score03+'">'+globalFunctions.checkQuotes(quotes.Score03)+'</li> '+
                                '<li data-betType="Other" data-betCode="666" class="bet-choose" data-odd="'+quotes.ScoreOther+'">'+globalFunctions.checkQuotes(quotes.ScoreOther)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/correct_score_2.js
// module id = 2009
// module chunks = 4